import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/lostPassword';
const $urlSendSms = '/lostPassword/actions/sendSms';

interface ISubmitRequest
{
    mobile: string;
    code: string;
    password: string;
}

interface ISendSmsRequest
{
    mobile: string;
}

export default {
  sendSms(req: ISendSmsRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlSendSms, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  submit(req: ISubmitRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($url, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
